import './header.css';
import './responsive.css';
import { RiBehanceFill } from 'react-icons/ri';

import logoDalben from '../../assets/dalbenLogo.png';


export default function Header() {

    const perfil = {
        urlFoto: 'https://avatars.githubusercontent.com/u/59475371?v=4',
        skill: 'Desenvolvedor Front-End Web / React JS / Pricing & Dados',
        nameUser: 'João Lucas Melo de Souza'
    }

    const { urlFoto, skill} = perfil;

    return(

            <header className='containerHeader'>
                <img className='fotoPerfil' src= { urlFoto } alt="Foto Perfil Joao Lucas" />

                <div className='containerCard1'>
                    <div className='card1'>
                        <h2>{ skill }</h2>
                        <p>
                            Feito é melhor que perfeito 
                        </p>
                    </div>
                </div>
            

                <div className='containerCard2'>
                    <div className='card2'>
                        <p>PORTFOLIO</p>

                        <div className='textInfo'>
                            <h2>Inspirado pela Behance</h2>
                            <RiBehanceFill size={100}/>
                        </div>
                            <p>Desenvolvido Por João Lucas Melo</p>
                    </div>

                    <div className='containerInfo'>
                        <div className='info'>
                            <span>Price analyst And Data Supermercados Dalben</span>
                            <img className='logoDalben' src= { logoDalben } alt=" Logo Dalben Supermercados" />
                        </div>
                    </div>

                </div>
            </header>

    )
}